import "../assets/Text.css";
import { ref as X, computed as p, defineComponent as K, openBlock as f, createElementBlock as b, normalizeClass as Z, unref as g, normalizeStyle as U, withModifiers as ee, createElementVNode as L, createCommentVNode as te, createVNode as ne, Fragment as oe, renderList as ae, createBlock as j, resolveDynamicComponent as ie } from "vue";
import { d as re } from "./debounce.BDLEW31m.js";
import { p as se } from "./widgets-core.es.DdX21Kyh.js";
import { h as l, A as y, e as i, i as G, g as T, L as v, D as B, j as le, T as $ } from "./maps.ChaVcqWI.js";
import { q as ue, e as z, i as de, o as q, s as pe, B as x } from "./useStore.DvPy8fc7.js";
function ce(n) {
  return n && n.length ? n[0] : void 0;
}
const me = {
  [l.ApplyPromoCode]: y.ApplyDiscount,
  [l.CloseTool]: y.NoAction,
  [l.EmailCapture]: y.SendSubscribe,
  emailCapture: y.SendSubscribe,
  [l.SendForm]: y.SendForm,
  [l.OpenUrl]: y.OpenUri,
  [l.CallPhoneNumber]: y.OpenUri,
  [l.OpenMailClient]: y.OpenUri,
  [l.SavedSearch]: y.SendSaveSearch,
  savedSearch: y.SendSaveSearch,
  [l.OpenBookingEngine]: y.OpenBookingEngine,
  [l.LastSearch]: y.OpenBookingEngine
};
function D(n) {
  return me[n];
}
const O = ue();
let F = 0;
function ye() {
  return F += 1, `extra-modules-${F}`;
}
function w(n) {
  const e = O.getLiteral(n), t = {
    [O.language]: e
  };
  return {
    sync: !0,
    id: ye(),
    mobile: t,
    desktop: t
  };
}
function A(n = "") {
  return {
    ...w(n),
    moduleType: i.Heading
  };
}
function H(n = "") {
  return {
    ...w(n),
    moduleType: i.Paragraph
  };
}
function C(n, e) {
  return {
    ...w(e),
    moduleType: i.Button,
    behaviour: {
      type: n
    }
  };
}
const ge = {
  [i.EmailCapture]: "Your email address has been successfully added to our list.",
  [i.SavedSearch]: "We will send you an email with your search very soon.",
  [i.Form]: "We have received your form submission correctly"
}, N = {
  [l.ApplyPromoCode]: "Apply promocode",
  [l.OpenUrl]: "Continue",
  [l.CloseTool]: "Close",
  [l.OpenBookingEngine]: "Book Now",
  [l.OpenMailClient]: "Contact Now",
  [l.CallPhoneNumber]: "Call Now"
}, W = X(), he = [
  i.SavedSearch,
  i.EmailCapture,
  i.Form,
  i.Login
];
function fe(n) {
  var e;
  return ((e = n.find(
    (t) => he.includes(t.moduleType)
  )) == null ? void 0 : e.moduleType) || "";
}
function E(n) {
  var e;
  return (e = n.find(
    (t) => t.moduleType === i.Button
  )) == null ? void 0 : e.behaviour.type;
}
function Se(n, e) {
  return n.filter((t) => {
    if (t.moduleType !== i.Button) return !1;
    const o = t;
    return o.kind === G.Secondary && o.primaryButtonId === e;
  });
}
function Te(n) {
  return n.reduce((e, t) => {
    var r;
    if (t.moduleType !== i.Button) return [...e, t];
    if (t.kind === G.Secondary) return e;
    const u = Se(n, t.id);
    return [...e, {
      ...t,
      alignment: (r = ce(u)) == null ? void 0 : r.alignment,
      secondaryButtons: u
    }];
  }, []);
}
function Ke(n) {
  const e = Te(n), t = {
    [T.Main]: e
  }, o = fe(e), u = e.find(
    (h) => h.moduleType === i.Login
  );
  if (!o) return t;
  if (u) {
    const h = e.find(
      (m) => m.moduleType === i.Button
    );
    if (t[T.Main] = e.reduce((m, d) => d.moduleType === i.Button ? m : d.moduleType === i.Login ? [
      ...m,
      {
        ...d,
        buttonModule: h,
        currentView: v.LoginRegister
      }
    ] : [...m, d], []), t[v.LoginSignin] = e.reduce((m, d) => d.moduleType !== i.Login ? m : d.moduleType === i.Login ? [
      ...m,
      {
        ...d,
        buttonModule: h,
        currentView: v.LoginSignin
      }
    ] : [...m, d], []), !o)
      return t;
    const _ = E(e), R = N[_] || "Close";
    t[v.LoginSuccess] = e.reduce((m, d) => d.moduleType !== i.Login && d.moduleType !== i.Button ? m : d.moduleType === i.Button ? [
      ...m,
      {
        ...C(_, R)
      }
    ] : d.moduleType === i.Login ? [
      ...m,
      {
        ...d,
        currentView: v.LoginSuccess
      }
    ] : [...m, d], []);
    const Y = p(() => A("There has been an error.")), J = p(() => H("Something went wrong. Please, try again later.")), Q = p(() => C(l.GoMainStep, "Back"));
    return t[T.Failure] = [
      Y.value,
      J.value,
      Q.value
    ], t;
  }
  const c = E(e), r = N[c] || "Close", a = p(() => A("Thank you!")), s = p(() => H(
    ge[o]
  )), S = p(
    () => C(c, r)
  ), P = p(() => A("There has been an error.")), M = p(() => H("Something went wrong. Please, try again later.")), k = p(() => C(l.GoMainStep, "Back"));
  return t[T.Success] = [
    a.value,
    s.value,
    S.value
  ], t[T.Failure] = [
    P.value,
    M.value,
    k.value
  ], E(e) === "submit" && (t[T.Success].pop(), t[T.Failure].pop()), t;
}
const be = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function I(n = be, e = B.Desktop, t) {
  const {
    fontSize: o,
    lineHeight: u,
    letterSpacing: c
  } = n;
  let r;
  e === B.Desktop && t === le.Compact ? r = 0.865 : e === B.Mobile && o > 12 ? r = 0.8 : r = 1;
  let a = Math.round(o * r);
  e === B.Mobile && o > 12 && a < 12 && (a = 12);
  const s = Math.round(u), S = (c ?? 0) / 100;
  return {
    fontSize: z(a),
    lineHeight: z(s),
    letterSpacing: c ? de(S) : "normal"
  };
}
const ve = ["button-state", "moduleType", "data-module-id", "data-full-width", "aria-label", "aria-busy"], Pe = ["innerHTML"], Me = ["innerHTML"], ke = ["aria-label"], V = /* @__PURE__ */ K({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    isSecondary: { type: Boolean },
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = q(), { t } = se(), o = n, u = p(() => {
      var a;
      return e == null ? void 0 : e.literals.getActiveModuleText(
        o.moduleProps,
        ((a = e == null ? void 0 : e.styles.fonts[o.moduleProps.moduleType]) == null ? void 0 : a.textTransform) === $.Titlecase,
        {
          candidates: e.extraData.dynamicTags,
          replacement: e.extraData.tokens
        }
      );
    }), c = p(
      () => {
        var a;
        return I(
          o.moduleProps.appearance,
          e == null ? void 0 : e.device,
          (a = o.layout) == null ? void 0 : a.size
        );
      }
    ), r = re(() => {
      if ((e == null ? void 0 : e.handlers.buttonState) !== x.Sending)
        if (o.hasExtraSteps && !o.moduleProps.id.includes("extra"))
          W.value && (W.value.scrollTop = 0), e == null || e.handlers.callHandler(D(o.hasExtraSteps));
        else if (o.moduleProps.behaviour.type === l.GoMainStep)
          e == null || e.handlers.goBackToMainStep();
        else {
          const a = D(o.moduleProps.behaviour.type);
          e == null || e.handlers.callHandler(a, o.moduleProps.id);
        }
    }, 200, { leading: !0, trailing: !1 });
    return (a, s) => {
      var S, P, M, k;
      return f(), b("button", {
        class: Z([
          "thn--tool-button",
          {
            "inline-layout": a.isLinkLayout,
            "thn--tool-button__secondary": a.isSecondary,
            "bg-color": !a.isLinkLayout,
            "bg-color-secondary": !a.isLinkLayout && a.isSecondary
          }
        ]),
        "button-state": (S = g(e)) == null ? void 0 : S.handlers.buttonState,
        style: U(c.value),
        moduleType: a.moduleProps.moduleType,
        "data-module-id": a.moduleProps.id,
        "data-full-width": (P = a.moduleProps.appearance) == null ? void 0 : P.fullWidth,
        onMousedown: s[0] || (s[0] = ee(
          //@ts-ignore
          (...h) => g(r) && g(r)(...h),
          ["left"]
        )),
        onClick: s[1] || (s[1] = //@ts-ignore
        (...h) => g(r) && g(r)(...h)),
        "aria-label": u.value && g(pe)(u.value),
        "aria-busy": ((M = g(e)) == null ? void 0 : M.handlers.buttonState) === g(x).Sending ? "true" : "false"
      }, [
        a.isLinkLayout ? (f(), b("span", {
          key: 1,
          innerHTML: u.value
        }, null, 8, Me)) : (f(), b("span", {
          key: 0,
          class: "thn--tool-button__label",
          innerHTML: u.value
        }, null, 8, Pe)),
        ((k = g(e)) == null ? void 0 : k.handlers.buttonState) === g(x).Sending && !a.isLinkLayout ? (f(), b("div", {
          key: 2,
          class: "thn--tool-button__sending loader",
          "aria-label": g(t)("Sending"),
          "aria-live": "polite"
        }, s[2] || (s[2] = [
          L("div", { class: "la-ball-pulse" }, [
            L("div", { "aria-hidden": "true" }),
            L("div", { "aria-hidden": "true" }),
            L("div", { "aria-hidden": "true" })
          ], -1)
        ]), 8, ke)) : te("", !0)
      ], 46, ve);
    };
  }
}), Le = ["data-button-alignment"], we = /* @__PURE__ */ K({
  __name: "CTAGroup",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = n;
    return (t, o) => {
      var u;
      return f(), b("div", {
        class: "thn--tool-cta-group",
        "data-button-alignment": e.moduleProps.alignment ?? "horizontal"
      }, [
        ne(V, {
          "has-extra-steps": e.hasExtraSteps,
          "tool-kind": e.toolKind,
          layout: e.layout,
          "is-link-layout": ((u = e.moduleProps.appearance) == null ? void 0 : u.layout) === "link",
          "module-props": e.moduleProps
        }, null, 8, ["has-extra-steps", "tool-kind", "layout", "is-link-layout", "module-props"]),
        (f(!0), b(oe, null, ae(t.moduleProps.secondaryButtons, (c) => {
          var r;
          return f(), j(V, {
            key: c.id,
            "has-extra-steps": e.hasExtraSteps,
            "tool-kind": e.toolKind,
            "is-link-layout": ((r = c.appearance) == null ? void 0 : r.layout) === "link",
            "is-secondary": !0,
            layout: e.layout,
            "module-props": c
          }, null, 8, ["has-extra-steps", "tool-kind", "is-link-layout", "layout", "module-props"]);
        }), 128))
      ], 8, Le);
    };
  }
}), _e = /* @__PURE__ */ K({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = {
      [i.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [i.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [i.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    }, t = q(), o = n, u = p(() => {
      var s;
      return t == null ? void 0 : t.literals.getActiveModuleText(
        o.moduleProps,
        ((s = t == null ? void 0 : t.styles.fonts[o.moduleProps.moduleType]) == null ? void 0 : s.textTransform) === $.Titlecase,
        {
          candidates: t.extraData.dynamicTags,
          replacement: t.extraData.tokens
        }
      );
    }), c = p(
      () => o.moduleProps.appearance || e[o.moduleProps.moduleType]
    ), r = p(
      () => {
        var s;
        return I(c.value, t == null ? void 0 : t.device, (s = o.layout) == null ? void 0 : s.size);
      }
    ), a = p(() => o.moduleProps.moduleType === "heading" ? "h2" : o.moduleProps.moduleType === "paragraph" ? "p" : "div");
    return (s, S) => (f(), j(ie(a.value), {
      class: "thn--tool-text",
      style: U(r.value),
      innerHTML: u.value,
      "module-type": s.moduleProps.moduleType,
      "data-module-id": s.moduleProps.id,
      tabindex: "-1"
    }, null, 8, ["style", "innerHTML", "module-type", "data-module-id"]));
  }
});
export {
  _e as _,
  I as a,
  we as b,
  Te as c,
  V as d,
  D as g,
  fe as h,
  W as s,
  Ke as u
};
//# sourceMappingURL=Text.vue_vue_type_style_index_0_lang.BEQZVGlu.js.map
